import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SortDirection } from "../../interfaces";
import { Officer } from "../../interfaces/Officer";
import { officerSelectors } from "../../redux";
import { loadAllOfficer } from "../../redux/officer/sagaActions";

interface Column {
  id: "displayName" | "email" | "phoneNumber";
  label: string;
  minWidth?: number;
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: "displayName", label: "Nome", minWidth: 100 },
  {
    id: "email",
    label: "EMail",
    minWidth: 100,
  },
  {
    id: "phoneNumber",
    label: "Numero di telefono",
    minWidth: 100,
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  addButton: {
    marginTop: 20,
  },
});

interface TableOfficerProps {
  onEditOfficer: (holder: Officer | undefined) => void;
  onDeleteOfficer: (id: string) => void;
}

const TableOfficer: React.FC<TableOfficerProps> = ({
  onEditOfficer,
  onDeleteOfficer,
}) => {
  const officers = useSelector(officerSelectors.getAllOfficers);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const maxPage = Number(officers.data?.totalCount);
  const getOfficerById = useSelector(officerSelectors.getOfficerById);

  const handleSelectOfficer = (id: string) => {
    onEditOfficer(getOfficerById(id));
  };

  useEffect(() => {
    dispatch(loadAllOfficer({}));
  }, [dispatch]);

  const handleChangePage = (event: unknown, newPage: number) => {
    if (newPage > page) {
      dispatch(
        loadAllOfficer({
          start_after:
            officers.data?.results[officers.data?.results.length - 1].uid,
          sort_by: [{ field: "uid", order: SortDirection.ASC }],
        })
      );
    } else {
      dispatch(
        loadAllOfficer({
          end_before:
            officers.data?.results[officers.data?.results.length - 1].uid,
          sort_by: [{ field: "uid", order: SortDirection.ASC }],
        })
      );
    }
    setPage(0);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const deleteOfficer = (id: string) => {
    onDeleteOfficer(id);
  };

  if (!officers.data || officers.data?.results.length === 0) return null;

  return (
    <>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell align="right">Modifica</TableCell>
                <TableCell align="right">Cancella</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {officers.data?.results.map((row: Officer | null) => {
                return row ? (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row?.uid}>
                    {columns.map((column, index) => {
                      const value = row[column.id];
                      return (
                        <React.Fragment key={column.id + index}>
                          <TableCell>{value}</TableCell>
                        </React.Fragment>
                      );
                    })}

                    <TableCell align="right">
                      <Tooltip title="Modifica">
                        <IconButton
                          aria-label="edit"
                          onClick={() => handleSelectOfficer(row?.uid)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Elimina">
                        <IconButton
                          aria-label="delete"
                          onClick={() => deleteOfficer(row?.uid)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ) : null;
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={maxPage}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage="N. elementi"
        />
      </Paper>
    </>
  );
};

export default React.memo(TableOfficer);
